import { Service } from '@/tools'
export class DictionaryTableService<T extends TCommodity.DictionaryTable> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.DictionaryTable}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 字典表查询
  nameList = <K extends T['ApiNameList']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiNameList', data)

  // 字典表下拉查询(分页)-创建商品使用 /api/commodity/dictionaryTable/v1/queryNamePage
  queryNamePage = <K extends T['ApiQueryNamePage']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryNamePage', data)
}
